import React, { useState } from 'react';
import { Box, Stack, Button } from '@mui/material';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import MoreTimeRoundedIcon from '@mui/icons-material/MoreTimeRounded';
import { useSelector } from 'react-redux';
import OvertimePage from '../../pages/OvertimePage';
import OvertimeRequestScreen from './OvertimeRequestScreen';
import { selectUserTypeId, USER_TYPE } from '../../redux/slices/authSlice';
import { PRIMARY, PRIMARY_LIGHT, PRIMARY_DARK } from '../../theme';

export default function OvertimeHost() {
    const userTypeId = useSelector(selectUserTypeId);
    const isEmployee = userTypeId === USER_TYPE.EMPLOYEE;
    const isMasterAdmin = userTypeId === USER_TYPE.MASTER_ADMIN;
    const [view, setView] = useState('approvals');

    if (isEmployee) return <OvertimeRequestScreen />;
    if (isMasterAdmin) return <OvertimePage />;

    const tabs = [
        { key: 'approvals', label: 'Approvals', icon: FactCheckRoundedIcon },
        { key: 'claim', label: 'My OT Claim', icon: MoreTimeRoundedIcon },
    ];

    return (
        <Box>
            <Box sx={{ px: 2, pt: 2 }}>
                <Stack direction="row" spacing={0.6} sx={{ bgcolor: '#fff', border: '1px solid #E6EAF1', borderRadius: '9px', p: 0.6, width: 'fit-content' }}>
                    {tabs.map((t) => {
                        const active = view === t.key;
                        const Icon = t.icon;
                        return (
                            <Button
                                key={t.key}
                                onClick={() => setView(t.key)}
                                startIcon={<Icon sx={{ fontSize: 17 }} />}
                                sx={{
                                    textTransform: 'none', fontWeight: 700, fontSize: 13, borderRadius: '7px', px: 1.8, height: 36,
                                    color: active ? '#fff' : '#64748B',
                                    bgcolor: active ? PRIMARY : 'transparent',
                                    boxShadow: 'none',
                                    '&:hover': { bgcolor: active ? PRIMARY_DARK : PRIMARY_LIGHT },
                                }}
                            >
                                {t.label}
                            </Button>
                        );
                    })}
                </Stack>
            </Box>

            {view === 'approvals' ? <OvertimePage /> : <OvertimeRequestScreen />}
        </Box>
    );
}
